import { queryOptions } from '@tanstack/react-query';
import type { VendorBroadcastStatus } from '../model/schema';
import { vendorBroadcastApi } from './vendor-broadcast-api';

/** Query-key factory for the vendor-broadcast slice. */
export const vendorBroadcastKeys = {
  all: ['vendor-broadcasts'] as const,
  lists: () => [...vendorBroadcastKeys.all, 'list'] as const,
  list: (status: VendorBroadcastStatus | 'all', lang: string) =>
    [...vendorBroadcastKeys.lists(), status, lang] as const,
  unreadCount: () => [...vendorBroadcastKeys.all, 'unread-count'] as const,
};

/**
 * Poll cadence, carried over from the old panel: the list and the badge
 * re-read every 2 minutes and stay fresh for 90s between mounts. (The old
 * `cacheTime` of 5 minutes is TanStack v5's `gcTime` default — not restated.)
 */
const BROADCAST_POLL_MS = 2 * 60 * 1000;
const BROADCAST_STALE_MS = 90 * 1000;

export const vendorBroadcastQueries = {
  list: (status: VendorBroadcastStatus | 'all', lang: string) =>
    queryOptions({
      queryKey: vendorBroadcastKeys.list(status, lang),
      queryFn: () => vendorBroadcastApi.list(status === 'all' ? undefined : status),
      refetchInterval: BROADCAST_POLL_MS,
      refetchIntervalInBackground: true,
      staleTime: BROADCAST_STALE_MS,
    }),

  unreadCount: () =>
    queryOptions({
      queryKey: vendorBroadcastKeys.unreadCount(),
      queryFn: () => vendorBroadcastApi.unreadCount(),
      refetchInterval: BROADCAST_POLL_MS,
      refetchIntervalInBackground: true,
      staleTime: BROADCAST_STALE_MS,
    }),
};
